module.exports = __webpack_public_path__ + "static/img/行业实践_图5@2x.bcf3c37f.png";